import { request } from '_api/v1/base/document/client'

export const deleteDocumentBlank = async (blankId) => {
    return await request('DELETE', `documents/Blockings/${blankId}`)
}
